import React from 'react';
import PropTypes from 'prop-types';

import './CommonLinkActionButton.css';

function CommonLinkActionButton(props) {
  const { active, onClick, type, buttonText } = props;

  return (
    <div
      className="common-link-action-button__component"
      onClick={onClick}
      role="button"
      tabIndex={-1}
    >
      <div className={`icon-container${active ? ' active' : ''}`}>
        <div className={`icon ${type}`} />
      </div>
      <div className="undertext">{buttonText}</div>
    </div>
  );
}

CommonLinkActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  type: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};

CommonLinkActionButton.defaultProps = {
  active: null,
};

export default CommonLinkActionButton;
